import React from 'react';
import { useState, useEffect } from "react"
import DataTable from '../../../components/data-table/DataTable'
import Container from 'react-bootstrap/Container'
import BasicCard from "../../../components/basics/cards/BasicCard";
import Row from 'react-bootstrap/Row'

function CommentsTable( {resultsAndCommentsValue} ) {

    const tableConfig = {
        tableData: resultsAndCommentsValue?.scenarioSelection,
        tableColumns: ['Name', 'Type code', 'Last Updated at', 'User'],
        tableColumnIds: ['scenarioName', 'scenarioTypeCode', 'lastUpdateDate', 'userFullName'],
        handleRowClick: () => { }
    }

    return (
    <>
    {
        <Container fluid className='basic-listing-container'>
            <Row>
                {resultsAndCommentsValue?.scenarioSelection?.length > 0 &&
                    <div className='listing-table-wrapper'>
                    <DataTable tableConfig={tableConfig} downloadOptions={false}  />
                    </div>                 
                }
            </Row>
        </Container>
    }        
        </>
    );
}

export default CommentsTable;

